import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_021.jpg';
page.images = [
  {
    imageId: 'page021_zoom0',
    rectangle: {
      x: 607,
      y: 1324,
      width: 1180,
      height: 832,
    },
    imageSrc: 'images/page021/021 2.jpg',
  },
  {
    imageId: 'page021_zoom1',
    rectangle: {
      x: 604,
      y: 570,
      width: 1180,
      height: 725,
    },
    imageSrc: 'images/page021/021 1.jpg',
  },
];
page.games = [
  {
    id: 'page021_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1328,
    },
    item: {
      id: 'page021_game11',
    },
    rectangle: {
      id: 'page021_rect1',
    },
  },
  {
    id: 'page021_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 560,
    },
    item: {
      id: 'page021_game10',
    },
    rectangle: {
      id: 'page021_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page021_rect0',

    tooltip: '',

    linked: ['page021_game10'],
    x: 137,
    y: 560,
    width: 428,
    height: 398,
  },
  {
    id: 'page021_rect1',

    tooltip: '',

    linked: ['page021_game11'],
    x: 137,
    y: 1328,
    width: 450,
    height: 880,
  },
];
export default page;
